import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-faq-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './faq-section.component.html',
  styleUrls: ['./faq-section.component.scss']
})
export class FaqSectionComponent {
    @Input() fullWidth:boolean = false;
    public openFaqIndex: number | null = 0;

  public faqs = [
    {
      question: 'What is AI sports betting and how does it work?',
      answer:
        'AI sports betting uses machine learning—like reinforcement learning—to analyze outcomes and place bets that maximize long-term profits. Dimers Platinum is one of the best AI football prediction tools available, built specifically for college football, with more sports in the works',
    },
    {
      question: 'How can artificial intelligence improve sports betting picks?',
      answer: 'AI improves sports betting picks by analyzing hundreds of thousands of data points and reacting to line movement, team trends, and real-time results. This allows Dimers Platinum to serve as a sharp, responsive artificial intelligence football predictor.',
    },
    {
      question: 'What are the benefits over traditional betting?',
      answer: 'The benefits include efficiency, objectivity, and the ability to scale insights across thousands of games. This type of AI betting helps you make better decisions faster—and reduces the noise.',
    },
    {
      question: 'How much does Dimers Platinum cost?',
      answer: 'A one-off payment of $349 gets you full access to every college football AI pick for the entire 2025 season. There are no ongoing charges. Returning Platinum subscribers from last season can access a price freeze by purchasing early.',
    },
    {
      question: 'When are picks released? Will they be updated?',
      answer: 'Picks are released at set times each week, with occasional multiple drops depending on the slate. We recommend placing bets as soon as possible after release to lock in the best value, as odds may shift quickly. Picks are not updated once posted.',
    },
    {
      question: "Do I need Dimers Pro to access Platinum?",
      answer: 'No. Dimers Platinum is sold separately. You don’t need a Pro subscription.',
    },
    {
      question: 'What’s the best staking strategy?',
      answer: 'Backtesting shows flat staking and bet-to-win-$100 approaches both work well. You can choose what suits your bankroll best.',
    },
    {
      question: 'Will you help find the best odds?',
      answer: 'Yes—picks are posted with the best lines at the time of release. But if you have access to additional sportsbooks, always shop around to maximize your edge.',
    },
    {
      question: 'Does the AI model prefer underdogs or favorites?',
      answer: 'So far, there’s been a slight lean to the plus side of the line (+), a reflection of inefficiencies in first-quarter pricing. That could evolve as data grows.',
    },
  ];

  public toggleFaq(index: number): void {
    this.openFaqIndex = this.openFaqIndex === index ? null : index;
  }
}